if (!customElements.get('responsive-video')) {
  customElements.define(
    'responsive-video',
    class ResponsiveVideo extends HTMLElement {
      constructor() {
        super();

        this.videos = this.querySelectorAll('video');

        // Videos hidden by CSS keep playing, so pause everything when the layout switches
        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.mediaQuery.addEventListener('change', this.pauseAll.bind(this));

        if (this.hasAttribute('data-autoplay')) {
          this.initAutoplay();
        } else {
          this.initPlayButton();
        }
      }

      get visibleVideo() {
        return Array.from(this.videos).find((video) => video.offsetWidth > 0);
      }

      pauseAll() {
        this.videos.forEach((video) => video.pause());
      }

      initAutoplay() {
        // Only the video shown by CSS intersects, so the hidden one is never played or downloaded
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.play().catch(() => {});
              } else {
                entry.target.pause();
              }
            });
          },
          { threshold: 0.1 }
        );
        this.videos.forEach((video) => observer.observe(video));

        // Autoplay in iOS low power mode. HTMLMediaElement.prototype 'playing' is defined in global.js
        document.body.addEventListener('click', this.forceAutoplay.bind(this));
        document.body.addEventListener('touchstart', this.forceAutoplay.bind(this));
      }

      forceAutoplay() {
        const video = this.visibleVideo;
        if (video && !video.playing) {
          video.play().catch(() => {});
        }
      }

      initPlayButton() {
        this.coverImage = this.querySelector('[data-cover-image]');
        this.playButton = this.querySelector('[data-play-btn]');

        if (this.playButton) {
          this.playButton.addEventListener('click', this.revealVideo.bind(this));
        }
      }

      revealVideo() {
        const video = this.visibleVideo;
        if (video) video.play().catch(() => {});

        if (this.coverImage) {
          this.coverImage.style.opacity = '0';
          setTimeout(() => {
            this.coverImage.style.display = 'none';
          }, 500);
        }
      }
    }
  );
}
